export default "__VITE_ASSET__CtJNq9iB__"